import { createUseStyles } from "react-jss";
import {
    borderColor,
    controlBackgroundColor,
    foregroundColor,
    progressBarValueColor,
    progressBarVerticalPositon,
} from "../../theme/Mixins";

export default createUseStyles({
    progress: {
        composes: "progress",
        height: ({ theme }) => theme.ProgressBarHeight,
        margin: ({ theme }) => (theme.ProgressBarType === "floating" ? 0 : [[29, 0]]),
        fontSize: 0,
        position: ({ theme, isMobilePreview }) =>
            theme.ProgressBarType === "floating" && (isMobilePreview ? "absolute" : "fixed"),
        top: ({ theme, position, simulatedBannerVisible }) =>
            position === "top" && progressBarVerticalPositon(theme, simulatedBannerVisible),
        bottom: ({ theme, position }) => position === "bottom" && progressBarVerticalPositon(theme),
        left: 0,
        width: "100%",
        zIndex: 10,
    },
    bar: {
        composes: "progress__bar",
        zIndex: ({ isMobilePreview }) => isMobilePreview && 1,
        width: ({ isMobilePreview }) => isMobilePreview && "100%",
        marginLeft: ({ isMobilePreview }) => isMobilePreview && "0px",
        top: ({ isMobilePreview, position }) => isMobilePreview && position === "bottom" && "692px",
        cursor: ({ isMobilePreview }) => isMobilePreview && "not-allowed",
        transform: ({ isMobilePreview, position }) =>
            isMobilePreview && position === "top" && "translateY(0px)",
        position: "relative",
        background: ({ theme }) => controlBackgroundColor(theme),
        borderRadius: ({ theme }) =>
            theme.ProgressBarType === "floating"
                ? 0
                : Math.min(theme.BorderRadius, theme.ProgressBarHeight / 2),
        boxShadow: ({ theme }) =>
            theme.ProgressBarType === "floating"
                ? undefined
                : `0 0 0 ${Math.min(theme.BorderWidth, 1)}px ${theme.ControlBorderColor} inset`,
        overflow: "hidden",
        height: ({ theme }) => theme.ProgressBarHeight,
    },
    fill: {
        composes: "progress__fill",
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        transition: "width 600ms ease",
        background: ({ theme }) => theme.PrimaryColor,
        overflow: "hidden",
    },
    innerValue: {
        position: "absolute",
        top: 0,
        bottom: 0,
        width: 200,
        marginLeft: -100,
        textAlign: "center",
        color: ({ theme }) => progressBarValueColor(theme, 0),
        fontSize: ({ theme }) => theme.ProgressBarFontSize,
        lineHeight: ({ theme }) => `${theme.ProgressBarHeight}px`,
    },
    innerFillValue: {
        position: "absolute",
        top: 0,
        bottom: 0,
        width: 200,
        marginLeft: -100,
        textAlign: "center",
        color: ({ theme }) => progressBarValueColor(theme, 100),
        fontSize: ({ theme }) => theme.ProgressBarFontSize,
        lineHeight: ({ theme }) => `${theme.ProgressBarHeight}px`,
    },
    bottomRightValue: {
        width: 200,
        marginLeft: "auto",
        marginRight: 24,
        fontSize: ({ theme }) => theme.ProgressBarFontSize,
        textAlign: "right",
    },
    bottomValue: {
        width: 50,
        margin: "auto",
        fontSize: ({ theme }) => theme.ProgressBarFontSize,
        textAlign: "center",
        color: ({ theme }) => progressBarValueColor(theme, 100),
    },
    floatingValue: {
        position: "absolute",
        top: ({ theme }) => theme.ProgressBarHeight + 8,
        width: 50,
        fontSize: ({ theme }) => theme.ProgressBarFontSize,
        textAlign: "center",
        marginTop: 4,
        marginLeft: -25,
        color: ({ theme }) => foregroundColor(theme, theme.PrimaryColor),
        background: ({ theme }) => theme.PrimaryColor,
        borderRadius: ({ theme }) => Math.min(theme.BorderRadius, 8),
        boxShadow: ({ theme }) =>
            `0 0 0 ${theme.BorderWidth}px ${borderColor(theme, theme.PrimaryColor)}`,
        opacity: "0",
        pointerEvents: "none",
        transition: "left 600ms ease, opacity 200ms",
    },
    floatingValueHover: {
        opacity: "1",
    },
    floatingValueArrowBorder: {
        border: [[8, "solid", "transparent"]],
        borderBottomColor: ({ theme }) => borderColor(theme, theme.PrimaryColor),
        display: "block",
        content: "",
        position: "absolute",
        top: ({ theme }) => -16 - theme.BorderWidth,
        left: 17,
    },
    floatingValueArrow: {
        border: [[8, "solid", "transparent"]],
        borderBottomColor: ({ theme }) => theme.PrimaryColor,
        display: "block",
        content: "",
        position: "absolute",
        top: -16,
        left: 17,
    },
});
